import { render, staticRenderFns } from "./AITemplates.vue?vue&type=template&id=f5403a3e"
import script from "./AITemplates.vue?vue&type=script&lang=js"
export * from "./AITemplates.vue?vue&type=script&lang=js"
import style0 from "./AITemplates.vue?vue&type=style&index=0&id=f5403a3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports